
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators, IValidatingObject } from './../../../scripts/formcontrols'
import { MedProfileDto, MedRoundDto } from "./../../../dto/Dtos"

import Dal from './../../../scripts/dataaccess';

class MedProfileItemController extends FormPageValidator {
    public medProfile: MedProfileDto;
    
    public taken           : FormElementController<number>;
    public returned        : FormElementController<number>;
    public destroyed       : FormElementController<number>;
    public received        : FormElementController<number>;
    public broughtForward  : FormElementController<number>;
    public carryForward    : FormElementController<number>;
    public dispensationItemId: string;

    public checkedIn: boolean;

    get changed(): boolean {
        return this.broughtForwardChanged
            //|| this.carryForwardChanged
            || this.takenChanged
            || this.returnedChanged
            || this.destroyedChanged
            || this.checkedIn != this.medProfile.checkedIn;
    }

    get broughtForwardChanged(): boolean {
        var broughtForward = this.medProfile.broughtForwardUserOverride ? this.medProfile.broughtForward : this.medProfile.expectedBroughtForward;
        return this.broughtForward.value != broughtForward;
    }
    get takenChanged(): boolean {
        return this.taken.value != this.medProfile.taken;
    }
    get returnedChanged(): boolean {
        return this.returned.value != this.medProfile.returned;
    }
    get destroyedChanged(): boolean {
        return this.destroyed.value != this.medProfile.destroyed;
    }
    //get carryForwardChanged(): boolean {
    //    return this.carryForward.value != this.medProfile.carryForward;
    //}

    get carryForwardCalculated(): number {
        return +this.broughtForward.value + this.received.value - this.destroyed.value - this.taken.value - this.returned.value;
    }

    constructor(dto: MedProfileDto) {
        super();

        this.medProfile = dto;


        this.taken            = new FormElementController<number>("taken", this.medProfile.taken           );
        this.returned         = new FormElementController<number>("returned", this.medProfile.returned        );
        this.destroyed        = new FormElementController<number>("destroyed", this.medProfile.destroyed       );
        this.received = new FormElementController<number>("received", this.medProfile.received);

        var broughtForward = this.medProfile.broughtForwardUserOverride ? this.medProfile.broughtForward : this.medProfile.expectedBroughtForward;

        this.broughtForward = new FormElementController<number>("broughtForward ", broughtForward  );
        this.carryForward     = new FormElementController<number>("carryForward", this.medProfile.carryForward);
        this.checkedIn = this.medProfile.checkedIn;
        this.dispensationItemId = this.medProfile.dispensationItemId;
    }



    public GetUpdatedObject(): MedProfileDto {

        var updated = Object.assign({}, this.medProfile) as MedProfileDto;

        updated.taken               = this.taken.value;
        updated.returned            = this.returned.value;
        updated.destroyed           = this.destroyed.value;
        updated.received            = this.received.value;
        updated.broughtForward      = this.broughtForward.value;
        updated.carryForward        = this.carryForward.value;
        updated.dispensationItemId  = this.dispensationItemId;
        updated.checkedIn           = this.checkedIn;

        return updated;
    }
}


export default class MedProfileController extends FormPageValidator {

    public Items: Array<MedProfileItemController>;
    public startDate: Date;
    public endDate: Date;
    public patientId: string;
    constructor() {
        super();

        this.Items = new Array<MedProfileItemController>();
    }

    public Load(patientId: string, startDate: Date, endDate: Date) {

        this.startDate = startDate;
        this.endDate = endDate;
        this.patientId = patientId;

        var dal = new Dal();
        this.Items = [];

        dal.GetMedProfile(patientId, startDate, endDate).then(data => {
            console.log("Med Profile ", data);
            for (var item of data) {
                this.Items.push(new MedProfileItemController(item));
            }
        });
    }

    public Reload() {
        var dal = new Dal();
        this.Items = [];

        dal.GetMedProfile(this.patientId, this.startDate, this.endDate).then(data => {
            console.log("Med Profile ", data);
            for (var item of data) {
                this.Items.push(new MedProfileItemController(item));
            }
        });
    }

    public async Save() : Promise<Boolean> {
        var dal = new Dal();
        var result = new Array<MedProfileDto>();
        for (var item of this.Items) {
            result.push(item.GetUpdatedObject());
        }
        //console.log(result);
        return await dal.SaveMedProfile(this.patientId, this.startDate, this.endDate, result).then(result => {
            if (result) {
                this.Reload()
            }
            return Promise.resolve(result);

        });
    }


    public CheckinAllItems() {
        for (var item of this.Items) {
            item.checkedIn = true;
        }
    }

    get ChangeCount(): number {
        return this.Items.filter(i => i.changed).length;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/MedProfileForm/medProfileController.ts